import React from 'react';
import { Modal, Row, Col, } from 'react-bootstrap';
import OrdersActionCreators from 'actions/OrdersActionCreators';
import { useTranslation } from 'react-i18next';
const RemoveEquipmentModal = (props) => {
    const { t } = useTranslation();
    return (React.createElement(Modal, { show: props.show, bsSize: "sm" },
        React.createElement(Modal.Header, null,
            React.createElement(Modal.Title, null,
                t('REMOVE_CONTAINER_WITH_VALUE', { value: props.equipmentId }),
                "?")),
        React.createElement(Modal.Footer, null,
            React.createElement(Row, null,
                React.createElement(Col, { xs: 5 }),
                React.createElement(Col, { xs: 7 },
                    React.createElement("div", { className: "flex flex-row" },
                        React.createElement("button", { className: "button button-green hover:bg-green-dark text-white", onClick: () => {
                                OrdersActionCreators.removeEquipmentFromOrder(props.orderId, props._id);
                                props.onClose();
                            } }, t('CONFIRM')),
                        React.createElement("button", { className: "button bg-white text-grey hover:text-grey-dark", onClick: () => {
                                props.onClose();
                            } }, t('CANCEL'))))))));
};
export default RemoveEquipmentModal;
